import instance from '@/http';
export default {
	getFactoringList() {
		return instance().get(`/factoring`).then(resp => resp).catch(error => error);
	},
	setSafetyCalendar(data) {
		return instance().post(`/safety`, data).then(resp => resp.data).catch(error => error);
	},
	updateSafetyStatus(data) {
		return instance().post(`/safety/status`, data).then(resp => resp.data).catch(error => error);
	},
	updateSafetyHours(data) {
		return instance().post(`/safety/hours`, data).then(resp => resp.data).catch(error => error);
	},
	getDataSafety(data) {
		return instance().get(`/${ data }`, { limit: 999999 }).then(resp => resp.data).catch(error => error);
	},
	getDriver(data) {
		return instance().get(`/drivers/${ data }`).then(resp => resp.data).catch(error => error);
	},
	saveDriver(data) {
		return instance().post(`/drivers/new`, data).then(resp => resp).catch(error => error);
	},
	updateDriver(data) {
		return instance().post(`/drivers/update/${ data.id }`, data).then(resp => resp).catch(error => error);
	},
	deleteDriver(data) {
		return instance().delete(`/drivers/${ data.id }`).then(resp => resp.data).catch(error => error);
	},
	getTruck(data) {
		return instance().get(`/trucks/${ data }`).then(resp => resp.data).catch(error => error);
	},
	saveTruck(data) {
		return instance().post(`/trucks/new`, data).then(resp => resp).catch(error => error);
	},
	updateTruck(data) {
		return instance().post(`/trucks/update/${ data.id }`, data).then(resp => resp).catch(error => error);
	},
	deleteTruck(data) {
		return instance().delete(`/trucks/${ data.id }`).then(resp => resp.data).catch(error => error);
	},
	getTrailer(data) {
		return instance().get(`/trailers/${ data }`).then(resp => resp.data).catch(error => error);
	},
	saveTrailer(data) {
		return instance().post(`/trailers/new`, data).then(resp => resp).catch(error => error);
	},
	updateTrailer(data) {
		return instance().post(`/trailers/update/${ data.id }`, data).then(resp => resp).catch(error => error);
	},
	deleteTrailer(data) {
		return instance().delete(`/trailers/${ data.id }`).then(resp => resp.data).catch(error => error);
	},
	getCustomer(data) {
		return instance().get(`/customers/${ data }`).then(resp => resp.data).catch(error => error);
	},
	saveCustomer(data) {
		return instance().post(`/customers/new`, data).then(resp => resp).catch(error => error);
	},
	updateCustomer(data) {
		return instance().post(`/customers/update/${ data.division_id }`, data).then(resp => resp).catch(error => error);
	},
	deleteCustomer(data) {
		return instance().delete(`/customers/${ data.id }`).then(resp => resp.data).catch(error => error);
	},
	getNew() {
		return instance().get(`/drivers/getNew`).then(resp => resp.data).catch(error => error);
	},
	getCustomers() {
		return instance().post(`/getCustomers`).then(resp => resp.data).catch(error => error);
	},
	getTrailerInfo() {
		return instance().post(`/trailers/getTrailerInfo`).then(resp => resp.data).catch(error => error);
	},
	getDataLists(data) {
		return instance().post(`/trucks/getDriverTrailers`, data).then(resp => resp.data).catch(error => error);
	},
	getGeneralData() {
		return instance().post(`/general`).then(resp => resp.data).catch(error => error);
	},
	getGeneralCustomers(data) {
		return instance().post(`/safety/customerFilter`, data).then(resp => resp.data).catch(error => error);
	},
	setGeneralData(data) {
		return instance().post(`/safety/save`, data).then(resp => resp.data).catch(error => error);
	},
	getEmployee(data) {
		return instance().get(`/employees/${ data }/edit`).then(resp => resp.data).catch(error => error);
	},
	createEmployee() {
		return instance().get(`/employees/create`).then(resp => resp.data).catch(error => error);
	},
	saveEmployee(data) {
		return instance().post(`/employees`, data).then(resp => resp).catch(error => error);
	},
	updateEmployee(data) {
		return instance().put(`/employees/${ data.employee_id }`, data).then(resp => resp).catch(error => error);
	},
	deleteEmployee(data) {
		return instance().delete(`/employees/${ data.employee_id }`).then(resp => resp.data).catch(error => error);
	},
};
